import React from "react";
import { CircleAddIcon, ImageListItem } from "@molecules";
import { useStoreAppValue } from "@hooks";
import { RailsUrl } from "@services";

// import styled from "@emotion/styled";

// == Types ================================================================

// == Constants ============================================================

InviteNewMember.defaultProps = {};

// == Component ============================================================

export default function InviteNewMember() {
  const { inviteTeamUrl } = RailsUrl;
  const { campaignId } = useStoreAppValue();

  return (
    <>
      <ImageListItem
        leftComponent={<CircleAddIcon />}
        padding={[1, 2]}
        text="Invite New Members"
        onTouch={() => (window.location.href = inviteTeamUrl(campaignId))}
      />
    </>
  );
}

// == Styles ===============================================================
